export const isValidOAuthCallbackState = (returnedState: string | null, storedState: string | null): boolean =>
  returnedState !== null &&
  returnedState.length > 0 &&
  storedState !== null &&
  storedState.length > 0 &&
  returnedState === storedState;

type OAuthCallbackClaim = {
  current: boolean;
};

export const claimOAuthCallback = (claim: OAuthCallbackClaim, pathname: string, code: string | null): boolean => {
  if (claim.current || code === null || code.length === 0 || !pathname.includes("/auth/callback")) {
    return false;
  }

  claim.current = true;
  return true;
};
